import React from 'react';
import {
  FDBox,
  FDIcon,
  FDSecondaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { useHistory } from 'react-router-dom';
import { useNavigationContext } from 'Organisms/NavigationWithContext/NavigationContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { dataAttrs } from 'Helpers/Testing';
import { WizardProgressBar } from './WizardProgressBar';

export const RoadmapDeliverableNav = ({ navAwayRelationship = undefined, disabled = false }) => {
  const history = useHistory();
  const { setOpen, isInitializing } = useNavigationContext();
  const isMobile = useMobileLayout();
  const [loading, setLoading] = React.useState(false);
  const { pageContentResource, loadPageContentLink } = usePageContentContext();
  const { displayErrorMessage } = useSnackbarContext();

  // Dashboard is default
  const handleDashboardClick = () => {
    history.push('/');
  };

  const handleNavAwayRelationshipClick = async () => {
    try {
      setLoading(true);
      await loadPageContentLink(navAwayRelationship.link('related'));
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to navigate');
    } finally {
      setLoading(false);
    }
  };

  const progress = pageContentResource.attr('progress') || 0;

  return (
    <FDBox paddingY={2} width={'100%'} {...dataAttrs('roadmap-deliverable-nav')}>
      <FDStack direction={'column'} spacing={1} width={'100%'} alignItems={'center'}>
        <FDStack direction={'row'} justifyContent={'space-between'} alignItems={'center'} width={'100%'}>
          <IconButton
            size={'medium'}
            icon={MenuIcon}
            onClick={() => setOpen(true)}
            disabled={isInitializing || disabled}
            loading={isInitializing && !disabled}
          />
          {/* This here is to force the icon to be centered always no matter the screen size or the existence of the dashboard button */}
          <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
            <FDIcon size={'md'} icon={'fac'} />
          </div>
          {!isMobile && (
            navAwayRelationship ? (
              <FDSecondaryActionButton
                icon={navAwayRelationship.meta('icon')}
                size={'sm'}
                loading={loading}
                label={navAwayRelationship.meta('prompt')}
                onClick={handleNavAwayRelationshipClick}
                {...dataAttrs('navigate-away-button')}
              />
            )
              : (
                <FDSecondaryActionButton
                  icon={'navDashboard'}
                  size={'sm'}
                  label={'Dashboard'}
                  onClick={handleDashboardClick}
                />
              )
          )}
        </FDStack>
        <FDStack direction={'row'} width={'100%'}>
          {/* This is to make sure that the progress bar is always aligned to the button icon that has padding on the left */}
          <div style={{ width: '12px' }} />
          <WizardProgressBar progress={progress} />
        </FDStack>
      </FDStack>
    </FDBox>
  );
};
